module.exports = __webpack_public_path__ + "img/do-utilizador.f47fa635.svg";